// extracted by mini-css-extract-plugin
module.exports = {"row":"TabSubscription_row_1aghx","column":"TabSubscription_column_CG8EX","card":"TabSubscription_card_3acdO","metatext":"TabSubscription_metatext_1kwIo"};